import PlaceholderPage from './Placeholder';
export default function SettingsPage() {
  return <PlaceholderPage title="系统设置" hint="PRD §11 · 待 Phase 6 实现" />;
}
